import { sniffUserBrowserExtensions } from '@atlaskit/editor-common/utils';

export function getBrowserExtensions() {
	return sniffUserBrowserExtensions({
		extensions: ['grammarly'],
	});
}
